// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3ju5t","item":"PaymentsMobile_item__ierwD","label":"PaymentsMobile_label__1eOwa","amount":"PaymentsMobile_amount__tEr2u"};